<template>
  <div class="app">
    <AppHeader fixed>
      <b-navbar-nav class="space">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logo-inpar.png" height="25" alt="Inpar" />
        <img class="navbar-brand-minimized" src="img/logo-inpar.png" height="30" alt="Inpar" />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <!-- Pass filteredNav to SidebarNav -->
        <!-- <SidebarNav :navItems="filteredNav" /> -->
        <SidebarNav :navItems="filteredNav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!-- Aside -->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!-- Footer -->
      <div>
        <span class="ml-1">&copy; 2024 Publicis Groupe</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      dsrPaymentMethod: null,
      dealerId: null, 
      dsrType:null,
      nav: nav.items
    }
  },

  async mounted() {
    await this.fetchDsrId();
  },
  computed: {
    filteredNav() {
      console.log(this.nav)
      return this.nav.filter((item) => {
        // Check role-based permissions
        const hasPermission = !item.permission || this.$auth.check(item.permission);

        // Check custom conditions, if any
        const meetsCondition = !item.condition || item.condition(this.dsrPaymentMethod, this.dealerId, this.dsrType);

        return hasPermission && meetsCondition;
      });
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  methods: {
    async fetchDsrId() {
      try {
        const response = await this.axios.get('app/getDsrId');
        this.dsrPaymentMethod = response.data.payment_method;
        this.dealerId = response.data.dealer_id; 
        this.dsrType = response.data.dsr_type;
      } catch (error) {
        console.error('Error fetching DSR ID:', error);
      }
    },
  }
}
</script>
